export const getSalaryValue = ({
  currency,
  yearlySalary,
  monthlySalary,
  dailySalary,
}) => {
  if (yearlySalary) {
    return `${yearlySalary} ${currency} / ${I18n.t(
      'web.business_opportunities.requests.index.year',
    )}`;
  }

  if (monthlySalary) {
    return `${monthlySalary} ${currency} / ${I18n.t(
      'web.business_opportunities.requests.index.month',
    )}`;
  }

  if (dailySalary) {
    return `${dailySalary} ${currency} / ${I18n.t(
      'web.business_opportunities.requests.index.day',
    )}`;
  }
};
